import { CreditCard, Landmark } from 'lucide-react';

const OPTIONS = [
  { value: 'card', label: 'Carte bancaire', hint: 'Paiement sécurisé immédiat', Icon: CreditCard },
  { value: 'bank_transfer', label: 'Virement', hint: 'Coordonnées envoyées par email', Icon: Landmark },
];

export const PaymentMethodPicker = ({ value, onChange }) => (
  <div data-testid="payment-method-picker">
    <p className="text-sm font-semibold text-gray-700 mb-2">Mode de paiement</p>
    <div className="grid grid-cols-2 gap-3">
      {OPTIONS.map(({ value: v, label, hint, Icon }) => (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          data-testid={`payment-method-${v}`}
          className={`text-left p-3 rounded-xl border-2 transition-colors ${
            value === v ? 'border-violet-600 bg-violet-50' : 'border-gray-200 hover:border-violet-300'
          }`}
        >
          <Icon size={20} className={value === v ? 'text-violet-600' : 'text-gray-500'} />
          <p className="font-semibold text-gray-800 text-sm mt-1">{label}</p>
          <p className="text-xs text-gray-500">{hint}</p>
        </button>
      ))}
    </div>
  </div>
);
